import { loadExternalResources } from '@/shared/utils/external-resources';
import { environment } from '@/environments/environment';

// eslint-disable-next-line unicorn/prefer-top-level-await
(async () => {
  await loadExternalResources(environment.externalResources);

  const { bootstrapApplication } = await import('@angular/platform-browser');
  const { AppComponent } = await import('@/app/app.component');
  const { appConfig } = await import('@/app/app.config');
  const { oAuthApplication } = await import('@/app/authentication/oauth-application');
  const { defineCustomElements: defineBethaComponents } = await import('bth-components/loader');
  const { applyPolyfills, defineCustomElements: defineEstruturaComponents } =
    await import('@betha-plataforma/estrutura-componentes/loader');

  const isCallbackUrl = (): boolean => {
    const path = globalThis.location.pathname;
    return path.includes('/callback');
  };

  if (isCallbackUrl()) {
    const isSilentCallback = globalThis.location.pathname.includes('/silent-callback');

    if (isSilentCallback) {
      window.parent.postMessage(globalThis.location.hash, globalThis.location.origin);
    } else {
      await oAuthApplication.handleCallback();
      globalThis.location.replace('/');
    }
  } else if (oAuthApplication.hasActiveSession()) {
    console.log('Usuário autenticado, iniciando aplicação...');
    await bootstrapApplication(AppComponent, appConfig);
    await applyPolyfills();
    await defineEstruturaComponents(globalThis as any);
    await defineBethaComponents(globalThis as any);
  } else {
    await oAuthApplication.login();
  }
})();
